// extracted by mini-css-extract-plugin
export default {"show-cursor":"show-cursor_dREph","App":"App_ekzQl","globalCanvas":"globalCanvas_P1pKP"};